/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PriceStatus = {
    Red: 'Red',
    Yellow: 'Yellow',
    Green: 'Green',
} as const;
export type PriceStatus = typeof PriceStatus[keyof typeof PriceStatus];

